import { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';
import useGallery from './useGallery';

const NavBar = ({ canGoBack = false, onBack }) => {

    const { isAuthenticated, loginWithRedirect, logout, error } = useAuth0();
    const { entries } = useGallery();
    const { pathname } = useLocation();

    // The only place an Auth0 failure becomes visible. A redirect that comes back
    // without a session — bad audience, refused code exchange, blocked web origin —
    // otherwise just returns you to the landing page looking logged out, with
    // nothing anywhere to say why.
    useEffect(() => {
        if (error) console.error('[Auth0]', error.name, '-', error.message, error);
    }, [error]);

    const login = () => loginWithRedirect();
    const handleLogout = () => logout({ logoutParams: { returnTo: window.location.origin } });

    const onGallery = pathname === '/gallery';

    return (
        <div id="navbar">
            {/* Left is where you came from, right is where you can go. Back sits by
                the wordmark because that corner is where people reach when a zoom
                went somewhere they didn't intend — previously the wordmark was the
                only thing there that looked like "start again", and it isn't. */}
            <div className="nav-lead">
                <Link to="/" className="wordmark">FractalArt</Link>
                {canGoBack &&
                    <button type="button" className="nav-link nav-back" onClick={onBack}>
                        <span aria-hidden="true">&larr;</span> Back
                    </button>}
            </div>
            <div className="nav-actions">
                {onGallery
                    ? <Link to="/explore" className="nav-link">Generator</Link>
                    : <Link to="/gallery" className="nav-link">
                          Gallery
                          {/* The count is the nudge: it tells you there is
                              something of yours in there worth going back for. */}
                          {entries.length > 0 && <span className="nav-count">{entries.length}</span>}
                      </Link>}
                {!isAuthenticated
                    ? <button type="button" className="nav-link" onClick={login}>Login</button>
                    : <button type="button" className="nav-link" onClick={handleLogout}>Logout</button>}
            </div>
        </div>
    );
};

export default NavBar;
